import { render, staticRenderFns } from "./confirm-recover.vue?vue&type=template&id=eb6ece30&scoped=true&"
import script from "./confirm-recover.vue?vue&type=script&lang=js&"
export * from "./confirm-recover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6ece30",
  null
  
)

export default component.exports